import styled from "styled-components";
// 
/* App.css */
export const SliderWrapper = styled.div`
background-color: #fff;
border-radius: 4px;
width: 892px;
`
export const SliderCard = styled.div`
font-family: 'Rubik';
font-weight: 400;
width: 100%;
position: relative;
font-family: Quicksand;
& .card-container {
  padding: 14px 0 8px 16px;
  display: flex;
  width: 100%;
  overflow: hidden;
  position: relative;
  gap: 8px;
  font-family: Quicksand;
  & .adDimention{
    width: 134px;
    height: 100%;
  }
  & .tabItem{
    cursor: pointer;
    border-radius: 12px;
    transition: transform 0.3s ease-in-out;
    height: 104px;
    font-family: Quicksand;
    flex-shrink: 0;
    & .bgImage{
      position: absolute;
      width: 100px;
      height: 104px;
      right: 0;
      bottom: 0;
    }
    & .redirectImg{
      width: 16px; 
      height: 16px;
      position: absolute;
      right: 10px;
      bottom: 10px;
    }
    &.opacityInactive{
      opacity: 0.6;
    }
    &.active{
        background-color: #EAF5FF;
        color: #008CFF;
        opacity: 1;
        border: 2px solid #2276E3;
    }
   
    & .cardWrapper{
      padding: 12px 10px;
      & .heading{
        font-size: 18px; 
        margin-bottom: 8px;
        color: #fff;
        font-family: Quicksand;
        font-weight: 600;
        text-shadow:-1px 4px #7f7f7f;
      }
      & .discText{
        font-size: 14px; 
       
        color: #fff;
        font-family: Quicksand;
        font-weight: 400
      }
    }

  }
  & .tickIcon{
    width: 20px;
    height: 20px;
    position: absolute;
    right: 8px;
    top: 8px;
  }
}
& button{
  background-color: #000;
  color: #fff;
  border: none;
  border-radius: 22px;
  position: absolute;
  top: 40%;
  z-index: 99;
  width: 28px;
  height: 28px;
  cursor: pointer;
  & .rightArrow{width: 20px; height: 20px; margin-top: 3px;}
  &:disabled{
    background-color: #ccc;
    cursor: not-allowed;
    display: none;
  }
}
& button.button-left{
  left: 10px;
  & .rightArrow{
    transform: rotate(180deg);
  }
}
& button.button-right{
  right: 10px;
}
`






